import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Product3 from "../components/Product3";
import data from '../data/products3.json'

import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout>
          <Breadcrumb category={["metoder", "metoder"]}  page={["Tandkräm", "tandkram"]}/>
     <SEO title="Tandkräm" description="Recension av Tandkräm för vitare tänder" keywords={[`Tandkräm`, `Vita tänder`]}/>
    <main className="section-info">
    <section>
    <h1 class="welcome">Tandkräm</h1>
    <p className="text-center">
      Tandkräm av sig självt ger inte direkt några vita tänder. Dock så är det såklart viktigt att du sköter 
      om dina nya vita tänder. Så att köpa en <a href="https://adtr.co/TN8iAZ"  target="_blank" rel="noopener noreferrer">bättre tandkräm</a> kan hjälpa att behålla din tänder vita lite längre.</p>
      <p className="text-center">
      Tandkräm gör dina tänder renare och glattare och därmed naturligt vitare. Du behåller tändernas vita glans, 
      utan att skada och slita på dem. Tandkräm kan också motverka återuppbyggnad av färgpigment efter 
      tandblekningsbehandling samt löser upp färgpigment och slipar bort missfärgningar.
      </p>
      <h3 class="welcome">Tandkräm med slipeffekt</h3>
      <p className="text-center">
      Tandkrämer med lite större slipeffekt än de vanliga kan få tänderna att se vitare ut. 
      Använder man en sådan är det viktigt att inte borsta för hårt för att undvika att emaljen skadas. 
      </p>
      <h3 class="welcome">Tandkrämstabletter</h3>
      <p className="text-center">
      Med <a href="https://adtr.co/qGZO8W" target="_blank" rel="noopener noreferrer">Ben & Annas tandkräm tabletter</a> kan du på ett miljövänligt och roligt sätt få ett friskt leende. Dessa tabletter håller dina tänder friska med naturliga ingredienser som bakpulver, jäst, acacia och extrakt från mynta. Tabletterna innehåller fluor som ger ett extra skydd mot karies och är berikade med vitamin B12 för att förhindra vitaminbrist. Ben & Annas tandkräm tabletter är 100% veganvänliga och certifierad naturkosmetik.
      </p>
      </section>
  </main>
  <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Bästa tandkrämerna</h2>
     <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
     <Product3 produkt={data.tandkram}/>
    </main>
  </section>
  {/* <section className="section-faq">
    <FAQ />
  </section> */}
    <main className="section-info">
    <section>
    <h3 class="welcome">Vem behöver köpa en tandkräm och vad är bra att veta?</h3>
      <p className="text-center">
Svaret på denna fråga är ganska enkel: Alla. En tandkräm, som de flesta vet, hjälper till att hålla dina tänder och tandkött rena och fina, men en del borde införskaffa en speciell tandkräm om de lider av speciella besvär i munnen som exempelvis plack eller ilningar.
Vissa tandkrämer innehåller ämnen som motverkar ilningar, vilket kan vara skönt om man lider av det.
</p>
<p className="text-center">Det är exempelvis bra om en tandkräm bekämpar <a href="https://adtr.co/TN8iAZ"  target="_blank" rel="noopener noreferrer">karies</a> (som orsakar hål i tänderna) och som överlag ger skydd och rengör dina tänder. I denna kategori ingår även skydd för ditt tandkött.
</p>
<p className="text-center">Utöver det är det bra om du läser på vad för andra egenskaper tandkrämen har eftersom den då förbättrar din munhygien effektivare.
</p>
<p className="text-center">En annan sak du borde tänka på när du väljer tandkräm är om du har eller kommer bleka dina tänder eftersom du måste fortsätta ta hand om dina tänder efter blekningen. Då finns det tandkrämer speciellt utformade för det.
</p>
<p className="text-center">Om dina munbesvär inte blir bättre ska du självklart uppsöka en tandläkare eftersom du kanske kan ha en riktig tandsjukdom.</p>
<p className="text-center">
<h5 class="welcome">Påstående ett: ”Tandkrämer innehåller ett slags blått pigment”</h5>
<b>FALSKT.</b> Whiteningtandkrämer innehåller inte alls ett blått pigment. De innehåller istället bland annat Aqua, Alcohol, Menta piperita oil, Sodium lauryl sulfate, Sodium saccharin, Sucralose, Poloxamer 407, Sodium coco-sulfate, Disodium EDTA, Sodium citrate, Potassium hydroxide, Limonene samt Linalool. Dessa ingredienser är godkända av Livsmedelsverket som har strikta lagar kring vad man får ha för ingredienser i produkter som man applicerar på tänder, hud m.m.
</p><p className="text-center">
Förklaring: Man kan uppleva en blå nyans när man borstar tänderna med blekande whiteningtandkrämer, men detta är helt naturligt och försvinner efter någon behandling eller två.
</p><p className="text-center">
<h5 class="welcome">Påstående två: ”Det gick bara att se en liten effekt omedelbart efter borstning”</h5>
<b>SANT.</b> Detta beror på att blekande tandkrämer bleker tänderna successivt och slutresultatet syns efter 2-3 veckor. Ett startkit med tandblekning fungerar exempelvis på ett helt annat sätt än whiteningtandkrämer och du kan få upp till två nyansskillnader efter bara en behandling, men tandkrämer bleker alltså tänderna sakta – men säkert.
</p><p className="text-center">
Detta eftersom man endast borstar tänderna två minuter per gång till skillnad mot om man har en tandskena inne i munnen med verkande blekgel uppemot 30 minuter/omgång.
</p><p className="text-center">
<h5 class="welcome">Påstående tre: ”Slipmedlet sliter på tändernas rotytor och det är inte hälsosamt på lång sikt”</h5>
<b>SANT.</b> Man ska aldrig bleka tänderna ”hela tiden” eftersom tandkrämer och andra whiteningprodukter innehåller ämnen som polerar tänderna eftersom tanken är att man ska få bort hårt sittande och gamla missfärgningar. Man ska i regel endast bleka tänderna i 3 veckor som mest med exemeplvis ett whiteningskum, därefter håller sig tänderna rena, friska och vita i upp till 1 år. Sedan kan man bleka igen och så vidare.
</p>
    
    </section>
  </main>
  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout>
)

export default IndexPage
